import { c as _slicedToArray, _ as _objectSpread2 } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useContext, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Modal, Text, Input, Select, Label, Button, HideOnMobile, SelectTabs, BasePageLayout } from 'quanta-ui';
import { faSpinner, faExchangeAlt, faPowerOff, faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery, useMutation } from '@apollo/client';
import { a as CHECK_PERMISSION } from './queries-3df8abcc.js';
import { SWITCH_ROLE as SWITCH_ROLE$1 } from './permissions.js';
import { E as Error } from './error-ee5266a9.js';
export { E as Error } from './error-ee5266a9.js';
import { L as Loading } from './loading-c16d3bd3.js';
export { L as Loading } from './loading-c16d3bd3.js';
import { C as CHECKROLE_QUERY, S as SWITCH_ROLE, a as CHECKAUTH_QUERY, P as PROFILE_PIC } from './queries-a3e6305b.js';
import { a as ConfigContext } from './ConfigProvider-9522944e.js';
export { U as UnauthLayout } from './unauth-31a70615.js';

function ColorChooser(props) {
  var _useContext = useContext(ConfigContext),
      theme = _useContext.theme;

  var _useState = useState(localStorage.getItem('quanta:theme')),
      _useState2 = _slicedToArray(_useState, 2),
      selectedColor = _useState2[0],
      setSelectedColor = _useState2[1];

  var displayColorChooser = props.displayColorChooser,
      setDisplayColorChooser = props.setDisplayColorChooser;
  return /*#__PURE__*/React.createElement(Modal, {
    display: displayColorChooser,
    onClose: function onClose() {
      return setDisplayColorChooser(false);
    },
    title: "Choose Colors",
    size: "small"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-3 lg:grid-cols-4 space-x-2"
  }, theme.map(function (col, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center p-2",
      key: idx
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row cursor-pointer theme_".concat(col, " shadow"),
      onClick: function onClick() {
        return setSelectedColor(col);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-10 h-10 rounded-l bg-primary"
    }), /*#__PURE__*/React.createElement("div", {
      className: "w-10 h-10 rounded-r bg-secondary"
    })), /*#__PURE__*/React.createElement("div", {
      className: "pt-2"
    }, col));
  })), /*#__PURE__*/React.createElement(Text, {
    type: "title"
  }, "Preview"), /*#__PURE__*/React.createElement("div", {
    className: "mb-2 py-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: selectedColor ? "theme_".concat(selectedColor) : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-2"
  }, /*#__PURE__*/React.createElement(Input, {
    size: "full",
    type: "text",
    placeholder: "Sample Input"
  }), /*#__PURE__*/React.createElement(Select, {
    size: "full",
    type: "text",
    data: [{
      label: 'Sample Select',
      value: 'option1'
    }]
  }), /*#__PURE__*/React.createElement(Label, {
    text: "label",
    severity: "info"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "larger"
  }, "Text Content")), /*#__PURE__*/React.createElement(Button, {
    size: "full"
  }, "Sample Button")))), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    onClick: function onClick() {
      localStorage.setItem('quanta:theme', selectedColor);
      setDisplayColorChooser(false);
      document.body.classList.remove('overflow-y-hidden');
      window.location.reload();
    },
    className: "max-w-36"
  }, "Confirm Colors")));
}

function RoleChooser(props) {
  var displayRoleChooser = props.displayRoleChooser,
      setDisplayRoleChooser = props.setDisplayRoleChooser;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      targetRole = _useState2[0],
      setTargetRole = _useState2[1];

  var _useQuery = useQuery(CHECKROLE_QUERY, {
    fetchPolicy: 'cache-first',
    onCompleted: function onCompleted(_ref) {
      var checkAuth = _ref.checkAuth;
      return setTargetRole(checkAuth.role.roleName);
    }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  var _useMutation = useMutation(SWITCH_ROLE, {
    onCompleted: function onCompleted() {
      return window.location.reload();
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      switchRole = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      loadingSwitch = _useMutation2$.loading,
      errorRole = _useMutation2$.error;

  if (loading) return /*#__PURE__*/React.createElement(Loading, null);
  if (error) return /*#__PURE__*/React.createElement(Error, null);
  var checkAuth = data.checkAuth,
      userRoles = data.userRoles;
  var currentRole = checkAuth.role.roleName;
  var myRoles = userRoles.map(function (rol) {
    return rol.roleName;
  });
  return /*#__PURE__*/React.createElement(Modal, {
    display: displayRoleChooser,
    onClose: function onClose() {
      return setDisplayRoleChooser(false);
    },
    title: "Switch Role",
    size: "small"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-warning p-2 text-white rounded mb-2"
  }, /*#__PURE__*/React.createElement("b", null, "WARNING"), " You'll lose all progress to the current transaction if you switch role,", /*#__PURE__*/React.createElement("br", null), " please make sure to save your work"), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 lg:grid-cols-2 md:space-x-2 px-2 md:px-0 pb-4 mt-4"
  }, /*#__PURE__*/React.createElement(Label, {
    text: "Current Role",
    severity: "info",
    className: "mb-4 md:mb-0"
  }, /*#__PURE__*/React.createElement(Text, {
    type: "larger",
    className: "h-full flex flex-row items-center pt-0 md:pt-2"
  }, currentRole)), /*#__PURE__*/React.createElement(Label, {
    text: "Change Role To"
  }, /*#__PURE__*/React.createElement(Select, {
    size: "full",
    data: myRoles.map(function (rol) {
      return {
        label: rol,
        value: rol
      };
    }),
    value: targetRole,
    onChange: function onChange(e) {
      return setTargetRole(e.target.value);
    }
  }))), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    disabled: !targetRole || currentRole === targetRole,
    onClick: function onClick() {
      return switchRole({
        variables: {
          input: {
            defaultRole: targetRole
          }
        }
      });
    },
    className: "max-w-36",
    iconPre: loadingSwitch ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSpinner,
      spin: true
    }) : undefined
  }, loadingSwitch ? 'Updating' : 'Confirm'), errorRole ? /*#__PURE__*/React.createElement("div", {
    className: "py-2 text-error"
  }, "ERROR: ", errorRole.message) : /*#__PURE__*/React.createElement(React.Fragment, null)));
}

/**
 * e.g usage
 *
 * const {  loading, errror, hasPermission } = useSecurity("write:theme");
 */

var useSecurity = function useSecurity(_ref) {
  var permission = _ref.permission;

  var _useQuery = useQuery(CHECK_PERMISSION, {
    fetchPolicy: 'cache-first',
    variables: {
      permission: permission
    }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  return {
    loading: loading,
    error: error,
    hasPermission: loading || error ? false : permission === SWITCH_ROLE$1 ? true : data ? data.hasPermission : false
  };
};

var headerBrand = function headerBrand(branding, menu, serviceType, setServiceType, emptyMenu) {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "quanta-brand"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "logo",
    src: branding.logo.small,
    className: "h-10 items-center mt-0 mr-2 justify-center md:justify-start",
    loading: "lazy"
  })), emptyMenu ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(HideOnMobile, null, /*#__PURE__*/React.createElement(SelectTabs, {
    value: serviceType,
    onChange: setServiceType,
    disableSep: true,
    data: menu.header.map(function (hdr) {
      return {
        icon: function icon() {
          return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: hdr.icon
          });
        },
        label: hdr.title,
        value: hdr.title
      };
    })
  })));
};

var headerActions = function headerActions(data, dataPic, setDisplayColorChooser, setDisplayRoleChooser, hasSwitchRolePermission, emptyMenu) {
  var _dataPic$userMyDetail = dataPic.userMyDetail.profile,
      firstName = _dataPic$userMyDetail.firstName,
      lastName = _dataPic$userMyDetail.lastName;
  dataPic.userMyDetail.profile.userImage;
  return {
    prefixActions: hasSwitchRolePermission ? emptyMenu ? [{
      title: 'Switch Role',
      icon: function icon() {
        return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faExchangeAlt,
          size: "2x"
        });
      },
      link: function link(_ref) {
        _ref.children;
        return /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0");
      },
      onClick: function onClick() {
        return setDisplayRoleChooser(true);
      }
    }] : [// {
    //   title: 'Change Colors',
    //   icon: () => (
    //     <FontAwesomeIcon icon={faSwatchbook} size="2x" />
    //   ),
    //   link: ({ children }) => <>&nbsp;</>,
    //   onClick: () => setDisplayColorChooser(true),
    // },
    {
      title: 'Switch Role',
      icon: function icon() {
        return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faExchangeAlt,
          size: "2x"
        });
      },
      link: function link(_ref2) {
        _ref2.children;
        return /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0");
      },
      onClick: function onClick() {
        return setDisplayRoleChooser(true);
      }
    }] : [// {
      //   title: 'Change Colors',
      //   icon: () => (
      //     <FontAwesomeIcon icon={faSwatchbook} size="2x" />
      //   ),
      //   link: ({ children }) => <>&nbsp;</>,
      //   onClick: () => setDisplayColorChooser(true),
      // },
    ],
    userInfo: {
      image: dataPic.userMyDetail.profile.userImage,
      imageAlt: "".concat(firstName ? firstName[0].toUpperCase() : '').concat(lastName ? lastName[0].toUpperCase() : ''),
      userName: data.checkAuth.userProfileName,
      role: data.checkAuth.role.roleName
    },
    suffixActions: emptyMenu ? [{
      title: 'Logout',
      icon: function icon() {
        return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faPowerOff,
          size: "2x"
        });
      },
      link: function link(_ref3) {
        var children = _ref3.children;
        return /*#__PURE__*/React.createElement(Link, {
          to: "/logout"
        }, children);
      }
    }] : [{
      title: 'Profile Settings',
      icon: function icon() {
        return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faCog,
          size: "2x"
        });
      },
      link: function link(_ref4) {
        var children = _ref4.children;
        return /*#__PURE__*/React.createElement(Link, {
          to: "/security/profile"
        }, children);
      }
    }, {
      title: 'Logout',
      icon: function icon() {
        return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faPowerOff,
          size: "2x"
        });
      },
      link: function link(_ref5) {
        var children = _ref5.children;
        return /*#__PURE__*/React.createElement(Link, {
          to: "/logout"
        }, children);
      }
    }]
  };
};

var sidebarMenu = function sidebarMenu(menu, serviceType, restrictPermissions, emptyMenu) {
  return emptyMenu ? [] : menu.header.find(function (hdr) {
    return hdr.title === serviceType;
  }).sidebar.filter(function (_ref6) {
    var link = _ref6.link;
    return link ? !restrictPermissions.find(function (_ref7) {
      var path = _ref7.path;
      return path === link;
    }) : true;
  }).map(function (sbr) {
    return _objectSpread2(_objectSpread2({}, sbr), {}, {
      icon: function icon() {
        return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: sbr.icon,
          size: "2x"
        });
      },
      link: function link(_ref8) {
        var children = _ref8.children;
        return /*#__PURE__*/React.createElement(Link, {
          to: sbr.link
        }, children);
      },
      submenu: sbr.submenu ? sbr.submenu.filter(function (_ref9) {
        var link = _ref9.link;
        return !restrictPermissions.find(function (_ref10) {
          var path = _ref10.path;
          return path === link;
        });
      }).map(function (smnu) {
        return _objectSpread2(_objectSpread2({}, smnu), {}, {
          link: function link(_ref11) {
            var children = _ref11.children;
            return /*#__PURE__*/React.createElement(Link, {
              to: smnu.link
            }, children);
          }
        });
      }) : undefined
    });
  }).filter(function (_ref12) {
    var submenu = _ref12.submenu;
    return !submenu || submenu.length > 0;
  });
};

var headerMenu = function headerMenu(menu, data, dataPic, emptyMenu, restrictPermissions) {
  var _dataPic$userMyDetail2 = dataPic.userMyDetail.profile,
      firstName = _dataPic$userMyDetail2.firstName,
      lastName = _dataPic$userMyDetail2.lastName;
  var userImage = dataPic.userMyDetail.profile.userImage;
  return {
    auth: {
      image: userImage,
      imageAlt: "".concat(firstName ? firstName[0] : '').concat(lastName ? lastName[0] : ''),
      userName: data.checkAuth.userProfileName,
      role: data.checkAuth.role.roleName
    },
    menu: emptyMenu ? [] : menu.header.map(function (hdr) {
      return _objectSpread2(_objectSpread2({}, hdr), {}, {
        sidebar: hdr.sidebar.filter(function (_ref13) {
          var link = _ref13.link;
          return link ? !restrictPermissions.find(function (_ref14) {
            var path = _ref14.path;
            return path === link;
          }) : true;
        }).map(function (sbr) {
          return _objectSpread2(_objectSpread2({}, sbr), {}, {
            icon: function icon() {
              return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
                icon: sbr.icon,
                size: "2x"
              });
            },
            link: function link(_ref15) {
              var children = _ref15.children;
              return /*#__PURE__*/React.createElement(Link, {
                to: sbr.link
              }, children);
            },
            submenu: sbr.submenu ? sbr.submenu.filter(function (_ref16) {
              var link = _ref16.link;
              return !restrictPermissions.find(function (_ref17) {
                var path = _ref17.path;
                return path === link;
              });
            }).map(function (smnu) {
              return _objectSpread2(_objectSpread2({}, smnu), {}, {
                link: function link(_ref18) {
                  var children = _ref18.children;
                  return /*#__PURE__*/React.createElement(Link, {
                    to: smnu.link
                  }, children);
                }
              });
            }) : undefined
          });
        }).filter(function (_ref19) {
          var submenu = _ref19.submenu;
          return !submenu || submenu.length > 0;
        })
      });
    })
  };
};

function Layout(_ref20) {
  var nav = _ref20.nav,
      service_type = _ref20.service_type,
      title = _ref20.title,
      subtitle = _ref20.subtitle,
      _ref20$emptyMenu = _ref20.emptyMenu,
      emptyMenu = _ref20$emptyMenu === void 0 ? false : _ref20$emptyMenu,
      children = _ref20.children;

  var _useContext = useContext(ConfigContext),
      branding = _useContext.branding,
      menu = _useContext.menu,
      routes = _useContext.routes;

  var _useState = useState(service_type),
      _useState2 = _slicedToArray(_useState, 2),
      serviceType = _useState2[0],
      setServiceType = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      displayColorChooser = _useState4[0],
      setDisplayColorChooser = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      displayRoleChooser = _useState6[0],
      setDisplayRoleChooser = _useState6[1];

  var _useQuery = useQuery(CHECKAUTH_QUERY, {
    fetchPolicy: 'cache-first'
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  var _useQuery2 = useQuery(PROFILE_PIC, {
    fetchPolicy: 'cache-first'
  }),
      loadingPIC = _useQuery2.loading,
      errorPIC = _useQuery2.error,
      dataPIC = _useQuery2.data;

  var _useSecurity = useSecurity({
    permission: SWITCH_ROLE$1
  }),
      hasSwitchRolePermission = _useSecurity.hasPermission;

  if (loading || loadingPIC) return /*#__PURE__*/React.createElement(Loading, null);
  if (error || errorPIC) return /*#__PURE__*/React.createElement(Error, null);
  var _data$checkAuth$role = data.checkAuth.role,
      permissions = _data$checkAuth$role.permissions,
      permissionType = _data$checkAuth$role.permissionType;
  var resPermissions = permissions.map(function (per) {
    return per.resourcePermission;
  });
  var restrict_permissions = routes.filter(function (route) {
    return route.permission;
  }).filter(function (_ref21) {
    var permission = _ref21.permission;
    return permissionType === 'allow-all' ? resPermissions.includes(permission) : !resPermissions.includes(permission);
  }).map(function (_ref22) {
    var permission = _ref22.permission,
        path = _ref22.path;
    return {
      permission: permission,
      path: path
    };
  });
  var header = {
    menu: headerMenu(menu, data, dataPIC, emptyMenu, restrict_permissions),
    brand: function brand() {
      return headerBrand(branding, menu, serviceType, setServiceType, emptyMenu);
    },
    actions: headerActions(data, dataPIC, setDisplayColorChooser, setDisplayRoleChooser, hasSwitchRolePermission, emptyMenu)
  };
  var sidebar = {
    activeMenu: nav[0],
    menu: sidebarMenu(menu, serviceType, restrict_permissions, emptyMenu)
  };
  var footer = menu.footer;

  var PageHelmet = function PageHelmet() {
    return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, nav.reduce(function (a, b) {
      return "".concat(a, " | ").concat(b);
    })));
  };

  return /*#__PURE__*/React.createElement(BasePageLayout, {
    header: header,
    sidebar: sidebar,
    title: title,
    subtitle: subtitle,
    nav: nav,
    footer: footer
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageHelmet, null), children, /*#__PURE__*/React.createElement(ColorChooser, {
    displayColorChooser: displayColorChooser,
    setDisplayColorChooser: setDisplayColorChooser
  }), /*#__PURE__*/React.createElement(RoleChooser, {
    displayRoleChooser: displayRoleChooser,
    setDisplayRoleChooser: setDisplayRoleChooser
  })));
}
var ClientService = 'Client Service';
var SelfService = 'Reports';

export { ClientService, Layout, SelfService };
